import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { EndFlowRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { EndFlowResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const endFlow = (request: EndFlowRequest, options?: CashRequestOptions) =>
  post<EndFlowRequest, EndFlowResponse>('/2.0/cash/end-flow', request, { ...options, rejectOnError: true })
